import React from "react";
import card_items from "./cards";
import resultCards from "./resultCards";
import chips from "../../../empty_chips";
import { Howl } from "howler";
import { connect } from "react-redux";
import cardspannel from "../../../../../../assets/games/AB_Classic/cardspannel.svg"
// import pannel from "../../../../../../assets/games/andarBaharTimer/ab_pannel.png"
import pannel from "../../../../../../assets/games/AB_Classic/A-box.svg"
import pannel2 from "../../../../../../assets/games/AB_Classic/B-box_1.svg"
import line from "../../../../../../assets/games/andarBaharTimer/lineandarbahar.png"
import bottomline from "../../../../../../assets/games/andarBaharTimer/bottomline.png"
import heart from "../../../../../../assets/games/andarBaharTimer/ab_heart.svg"
// import heart from "../../../../../../assets/games/andarBaharTimer/ab_heart.png"
import spade from "../../../../../../assets/games/andarBaharTimer/ab_spade.svg"
// import spade from "../../../../../../assets/games/andarBaharTimer/ab_spade.png"
import club from "../../../../../../assets/games/andarBaharTimer/ab_club.svg"
// import club from "../../../../../../assets/games/andarBaharTimer/ab_club.png"
import dimond from "../../../../../../assets/games/andarBaharTimer/ab_dimond.svg"
// import dimond from "../../../../../../assets/games/andarBaharTimer/ab_dimond.png"
import subttleandar from "../../../../../../assets/games/andarBaharTimer/andarsubtitle.png"
import subttlebahar from "../../../../../../assets/games/andarBaharTimer/baharsub.png"
import andarBet from "../../../../../../assets/games/AB_Classic/Andarr.svg";
// import andarBet from "../../../../../../assets/games/andarBaharTimer/andar_bet.png";
import baharBet from "../../../../../../assets/games/AB_Classic/Baharr.svg";
// import baharBet from "../../../../../../assets/games/andarBaharTimer/bahar_bet.png";
// import numBet1 from "../../../../../../assets/games/andarBaharTimer/ato6.png";
import numBet1 from "../../../../../../assets/games/andarBaharTimer/ato6.svg";
import numBet2 from "../../../../../../assets/games/andarBaharTimer/eighttok.svg";
// import numBet2 from "../../../../../../assets/games/andarBaharTimer/eighttok.png";
import bet_button from "../../../../../../assets/games/AB_Classic/bet_ok.svg";
import prev_button from "../../../../../../assets/games/AB_Classic/Prev.svg";
import glow_button from "../../../../../../assets/games/andarBaharTimer/ab_glow_btn.png";
import double_button from "../../../../../../assets/games/AB_Classic/Double.svg";
import clear_button from "../../../../../../assets/chips/chip_delete.png";
import totalbet from "../../../../../../assets/games/AB_Classic/Total_bet.svg";
// import ab_exitBtn from "../../../../../../assets/games/andarBaharTimer/ab_exitBtn.png";
import ab_glow from "../../../../../../assets/games/andarBaharTimer/ab_glow.png";
import one_sixGlowImg from "../../../../../../assets/games/andarBaharTimer/one_sixGlowImg.png";
import suitGlowImg from "../../../../../../assets/games/andarBaharTimer/suitGlowImg.png";
import baharHist from "../../../../../../assets/games/andarBaharTimer/baharHist.png";
import andarHist from "../../../../../../assets/games/andarBaharTimer/andarHist.png";
import cardGlow from "../../../../../../assets/games/andarBaharTimer/cardGlow.png";
import glowImg_a6 from "../../../../../../assets/games/andarBaharTimer/glow_a6.png";
import glowImg_8k from "../../../../../../assets/games/andarBaharTimer/glow_a6.png";
import abc_BgGlow from "../../../../../../assets/games/andarBaharTimer/abBgGlow.png";

import clearSound from "../../../../../../assets/sounds/clear.mp3";
import betSound from "../../../../../../assets/sounds/bet.mp3";
import takeSound from "../../../../../../assets/sounds/take.mp3";
import cardFallSound from "../../../../../../assets/sounds/slide.mp3";
import betoncard from "../../../../../../assets/sounds/betoncard.mp3";
import joker_card_anim from "../../../../../../assets/games/andarBaharTimer/joker_card_anim.gif";
import slotSound from "../../../../../../assets/sounds/Slot.wav";

import gsap from "gsap";

class ab_ChipsDealerPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.chipVal = [
      { label: "1", val: 1 },
      { label: "10", val: 10 },
      { label: "25", val: 25 },
      { label: "50", val: 50 },
      { label: "100", val: 100 },
      { label: "500", val: 500 },
      { label: "1k", val: 1000 },
      { label: "5k", val: 5000 },
      { label: "", val: 0 }
    ];

    this.state = {
      chipSelect: 1,
      index: -1,
      currentCard: 0,
      AndarCards: [],
      BaharCards: [],
      getRes: "",
      betResults: [],
      card_hover: true,
      andar_hover: false,
      bahar_hover: false,
      ato6_hover: false,
      hover_8tok: false,
      heart_hover: false,
      spade_hover: false,
      club_hover: false,
      dimond_hover: false,
      andarBg_0: false,
      andarBg_1: false,
      andarBg_2: false,
      andarBg_3: false,
      andarBgGlow: false,
      baharBgGlow: false,
      currentSound: null,
      isPlayingBet: false,
    };

    this.audio = null;
    this.audioD = null;
    this.cardsInt = "";
    this.startInt = null;
    this.updateHistoryData = [];
    this.winnerNameObj = [];
    this.History = []
    this.cardSound = this.initializeCardFallSound()



    this.clearSound = new Audio(clearSound);
    this.takeSound = new Audio(takeSound);

    this.betSound = new Audio(betSound);
    this.slotSound = new Howl({
      src: [slotSound],
      html5: true, // Enable HTML5 Audio for mobile compatibility
    });

    this.betoncard = this.initializeBetSound();
    this.Betsound = this.initializeBetPanelSound()
  }

  initializeBetSound = () => {
    try {
      const betSound = new Howl({
        src: [betoncard],
        html5: true, // Enable HTML5 Audio for mobile compatibility
      });
      this.setState({
        betoncard,
        isPlayingBet: false,
      });
      return betSound;
    } catch (error) {
      console.error("Error initializing bet sound:", error);
      return null;
    }
  };

  initializeCardFallSound = () => {
    try {
      const cardSound = new Howl({
        src: [cardFallSound],
        html5: true, // Enable HTML5 Audio for mobile compatibility
      });
      return cardSound;
    } catch (error) {
      console.error("Error initializing bet sound:", error);
      return null;
    }
  };
  initializeBetPanelSound = () => {
    try {
      const Betsound = new Howl({
        src: [betoncard],
        html5: true, // Enable HTML5 Audio for mobile compatibility
      });
      return Betsound;
    } catch (error) {
      console.error("Error initializing bet sound:", error);
      return null;
    }
  };


  playPokerBetSound = () => {
    const { currentSound } = this.state;

    // Stop the previous sound if it's still playing
    if (currentSound && (typeof currentSound.stop === 'function' || this.Betsound.stop === 'function')) {
      try {
        currentSound?.stop();
        this.Betsound?.stop()
      } catch (e) {
        console.warn('Error stopping previous sound:', e);
      }
    }

    // Create a new sound instance
    // const newSound = this.initializeBetSound();

    if (this.Betsound && typeof this.Betsound.play === 'function') {
      try {
        this.Betsound.play();
        this.setState({
          isPlayingBet: true,
          currentSound: this.Betsound, // Store it for next stop
        });
      } catch (e) {
        console.error('Error playing sound:', e);
      }
    } else {
      const newSound = this.initializeBetPanelSound()
      try {
        newSound.play();
        this.setState({
          isPlayingBet: true,
          currentSound: newSound, // Store it for next stop
        });
      } catch (e) {
        console.error('Error playing sound:', e);
      }
      console.error('Invalid sound object. Unable to play sound.');
    }
  };


  // playPokerBetSound = (chipSound) => {

  //   const { isPlayingBet } = this.state;
  //   // let currentSound = this.initializeBetSound();
  //   let currentSound = chipSound;

  //   if (isPlayingBet && chipSound) {
  //     try {

  //       chipSound.stop()
  //     } catch (e) { console.log(e) }
  //   }
  //   if (!chipSound) {
  //     currentSound = this.initializeBetSound();
  //   }
  //   if (currentSound) {

  //     currentSound.play()
  //     this.setState({
  //       isPlayingBet: true,
  //     });
  //   } else {
  //     console.error("Invalid sound object. Unable to play sound.");
  //   }

  // };
  //  playPokerBetSound = (chipSound) => {
  //   // this.Betsound.play()
  //   //   const clonedSound = this.Betsound.clone(); 
  //   // clonedSound.play();
  //   this.Betsound.play();
  // };

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);

    this.ab_ch_timeout2 = null;
    this.ab_ch_timeout3 = null;
    this.ab_ch_timeout4 = null;
    this.ab_ch_timeout5 = null;
    this.ab_ch_timeout6 = null;
    this.ab_ch_timeout7 = null;
    this.ab_ch_timeout8 = null;

    this.myCardAnim = null;
    this.myDlr = null;
    this.startInt = null;
    this.startIntCard = null;

    this.preloadImgs();
    this.preloadCards();

    this.clearSound = new Audio(clearSound);
    this.takeSound = new Audio(takeSound);

    this.betSound = new Audio(betSound);

    if (this.props.abt_chipValues) {
      let newChips = this.props.abt_chipValues.split(",");
      let lblTxt = "";

      for (let i = 0; i < newChips.length; i++) {
        if (Number(newChips[i]) >= 1000 && Number(newChips[i]) <= 999999) {
          lblTxt = "K"
        } else if (Number(newChips[i]) >= 1000000 && Number(newChips[i]) <= 999999999) {
          lblTxt = "M"
        } else if (Number(newChips[i]) > 999999999) {
          lblTxt = "B"
        }
        // console.log(newChips[i])

        this.chipVal[i].val = newChips[i]
        this.chipVal[i].label = newChips[i]

        this.chipVal[i].label = this.changeAmtlabl(this.chipVal[i].val)



        // this.checkChipValue(Number(this.chipVal[i].val), lblTxt, i);            
      }


      // this.setState({ chipSelect: Number(this.chipVal[0].val) });
      // this.state.chipSelect = Number(this.chipVal[0].val);
      // console.log(this.chipVal[0].val);
      // console.log(this.state.chipSelect);
    }

    //this.cardanimation();
    this.startVal = 0;

    // document.getElementById("timeSpan").style.display = "none";

    this.audio = new Audio(cardFallSound);
    this.audioD = new Audio(cardFallSound);

    // if (this.props.gameState.handId && this.props.gameState.handId !== this.props.gameState.oldHandId) {
    let resultCard = resultCards.find(ele => ele.rsc_val === this.props.gameState.joker)
    // console.log(resultCards[k].src);
    this.setJokerCard({ joker: resultCard?.rsc_val })
    // document.getElementById("resJokerCard").src = resultCards[k].src;
    // document.getElementById("resJokerCard").style.opacity = 0;
    // document.getElementById("topleft").textContent = resultCard.rsc_val.slice(0, -1) === 'T' ? '10' : resultCard.rsc_val.slice(0, -1);
    // document.getElementById("centerdiv").textContent = resultCard.rsc_val.slice(-1) === 'H' ? '♥' : resultCard.rsc_val.slice(-1) === "D" ? '♦' : resultCard.rsc_val.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("bottomright").textContent = resultCard.rsc_val.slice(-1) === 'H' ? '♥' : resultCard.rsc_val.slice(-1) === "D" ? '♦' : resultCard.rsc_val.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("topleft").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("centerdiv").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("bottomright").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("resJokerCard").style.display = "block";
    // document.getElementById("resJokerCard").style.opacity = 1;
    // document.getElementById("resJokerCard").style.opacity = 1;
    // document.getElementById("resJokerCard").style.opacity = 0;
    // document.getElementById("topleft").textContent = resultCard.rsc_val.slice(0, -1) === 'T' ? '10' : resultCard.rsc_val.slice(0, -1);
    // document.getElementById("centerdiv").textContent = resultCard.rsc_val.slice(-1) === 'H' ? '♥' : resultCard.rsc_val.slice(-1) === "D" ? '♦' : resultCard.rsc_val.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("bottomright").textContent = resultCard.rsc_val.slice(-1) === 'H' ? '♥' : resultCard.rsc_val.slice(-1) === "D" ? '♦' : resultCard.rsc_val.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("topleft").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("centerdiv").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("bottomright").style.color = resultCard.rsc_val.slice(-1) === 'H' || resultCard.rsc_val.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("resJokerCard").style.display = "block";
    // document.getElementById("resJokerCard").style.opacity = 1;
    // document.getElementById("resJokerCard").style.opacity = 1;
    // }


    if (this.props.gameState.takeAmount > 0 && this.props.gameState && this.props.gameState.response) {
      let andarCard = this.props.gameState.response.andharCards[this.props.gameState.response.andharCards.length - 1];
      let baharCard = this.props.gameState.response.baharCards[this.props.gameState.response.baharCards.length - 1];



      for (let k = 0; k < resultCards.length; k++) {

        // if (resultCards[k].rsc_val === this.props.gameState.response.joker) {
        //   // console.log(resultCards[k].src);
        //   // document.getElementById("resJokerCard").src = resultCards[k].src;
        //   document.getElementById("resJokerCard").style.opacity = 0;
        //   document.getElementById("topleft").textContent = resultCards[k].rsc_val.slice(0, -1) === 'T' ? '10' : resultCards[k].rsc_val.slice(0, -1);
        //   document.getElementById("centerdiv").textContent = resultCards[k].rsc_val.slice(0, -1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(0, -1) === "D" ? '♦' : resultCards[k].rsc_val.slice(0, -1) === "C" ? '♣' : '♠';
        //   document.getElementById("bottomright").textContent = resultCards[k].rsc_val.slice(-1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(-1) === "D" ? '♦' : resultCards[k].rsc_val.slice(-1) === "C" ? '♣' : '♠';
        //   document.getElementById("topleft").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
        //   document.getElementById("centerdiv").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
        //   document.getElementById("bottomright").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
        //   document.getElementById("resJokerCard").style.display = "block";
        //   document.getElementById("resJokerCard").style.opacity = 1;
        // }

        if (resultCards[k].rsc_val === andarCard) {
          // console.log(resultCards[k].src);
          // document.getElementById("res_andar_Card").src = resultCards[k].src;



          // const andarCardDiv = document.getElementById('res_andar_Card');
          // andarCardDiv.style.display = "block";
          // const card = this.createCardDiv(andarCard);
          // andarCardDiv.appendChild(card);
          // document.getElementById('res_andar_Card').style.display = "block";



          // document.getElementById("topleft").textContent = resultCards[k].rsc_val.slice(0, -1) === 'T' ? '10' : resultCards[k].rsc_val.slice(0, -1);
          // document.getElementById("centerdiv").textContent = resultCards[k].rsc_val.slice(0, -1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(0, -1) === "D" ? '♦' : resultCards[k].rsc_val.slice(0, -1) === "C" ? '♣' : '♠';
          // document.getElementById("bottomright").textContent = resultCards[k].rsc_val.slice(-1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(-1) === "D" ? '♦' : resultCards[k].rsc_val.slice(-1) === "C" ? '♣' : '♠';
          // document.getElementById("topleft").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
          // document.getElementById("centerdiv").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
          // document.getElementById("bottomright").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
          // let img = document.createElement('img');
          // img.classList.add("abc_baharBox_load");
          // img.src = resultCards[k].src;
          // document.getElementById('res_andar_Card').appendChild(img);

        }
        if (resultCards[k].rsc_val === baharCard) {
          // console.log(resultCards[k].src);
          // document.getElementById("res_bahar_Card").src = resultCards[k].src;



          // const baharCardDiv = document.getElementById('res_bahar_Card');
          // baharCardDiv.style.display = "block";
          // const card = this.createCardDiv(baharCard);
          // baharCardDiv.appendChild(card);
          // document.getElementById('res_bahar_Card').style.display = "block";




          // let img = document.createElement('img');
          // img.classList.add("abc_baharBox_load");
          // img.src = resultCards[k].src;
          // document.getElementById('res_bahar_Card').appendChild(img);

        }

      }
      // if (document.getElementById("resJokerCard")) {
      //   document.getElementById("resJokerCard")?.style?.opacity = 1;
      // }
      // if (document.getElementById("resJokerCard")) {
      //   document.getElementById("resJokerCard")?.style?.opacity = 1;
      // }
    }

    // document.getElementById("resJokerCard").src = joker_card_anim;
    // document.getElementById("resJokerCard").style.opacity = 1;


    // const animatecardsDiv = document.getElementById("animatecards");
    // animatecardsDiv.innerHTML = "";
    // card_items.map((cards, i) => {
    //   const createimage = document.createElement("img");
    //   createimage.src = cards.src;
    //   createimage.id = "animCard_" + i;
    //   createimage.style.opacity = 0.02;
    //   createimage.classList.add("jokerCard");
    //   animatecardsDiv.appendChild(createimage)
    // })


    // document.getElementById("res_andar_Card").classList.add("abc_andarBox");
  }

  changeAmtlabl(chngAmt) {
    let newAmt = Number(Number(chngAmt).toFixed(2));
    if (newAmt >= 1000 && newAmt <= 999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "K";
    } else if (newAmt >= 1000000 && newAmt <= 999999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "M";
    } else if (newAmt > 999999999) {
      newAmt = Number((newAmt / 1000).toFixed(2)) + "B";
    }
    return newAmt;
  }



  checkChipValue(chipValue, chpTxt, i) {
    if (chipValue >= 1000) {
      chipValue = chipValue / 1000;
      this.checkChipValue(chipValue, chpTxt, i)
    } else {
      // console.log(chpTxt);
      this.showResultChipValue(chipValue, chpTxt, i);
      return chipValue
    }
  }

  showResultChipValue(chVal, chipTxt, index) {
    // console.log(chVal);
    // console.log(chVal + "" + chipTxt)
    this.chipVal[index].label = chVal + "" + chipTxt;
    // console.log(this.chipVal)
  }

  componentWillUnmount() {
    this.audio = null;
    this.audioD = null;
    this.cardFallSound = null;
    this.setState({
      AndarCards: [],
      BaharCards: [],
    })
    if (this.slotSound) {
      try {
        this.slotSound.pause();
      } catch (e) {
        // console.log(e)
      }
      this.slotSound = null
      this.tickSound = null

    }
    clearInterval(this.myCardAnim);
    clearInterval(this.myDlr);
    clearInterval(this.startInt);
    clearInterval(this.startIntCard);

    window.clearTimeout(this.ab_ch_timeout2);
    window.clearTimeout(this.ab_ch_timeout3);
    window.clearTimeout(this.ab_ch_timeout4);
    window.clearTimeout(this.ab_ch_timeout5);
    window.clearTimeout(this.ab_ch_timeout6);
    window.clearTimeout(this.ab_ch_timeout7);
    window.clearTimeout(this.ab_ch_timeout8);
  }

  disableBetOptions() {
    this.removeWinGlow();

    clearInterval(this.startIntCard);
    clearInterval(this.myCardAnim);
    clearInterval(this.myDlr);
    clearInterval(this.startInt);

    window.clearTimeout(this.ab_ch_timeout2);
    window.clearTimeout(this.ab_ch_timeout3);
    window.clearTimeout(this.ab_ch_timeout4);
    window.clearTimeout(this.ab_ch_timeout5);
    window.clearTimeout(this.ab_ch_timeout6);
    window.clearTimeout(this.ab_ch_timeout7);
    window.clearTimeout(this.ab_ch_timeout8);
  }

  preloadCards() {

    for (let n = 0; n < 13; n++) {
      let card_img = new Image();
      card_img.src = card_items[n].src;
      // console.log(card_img.src);      
    }

    for (let z = 0; z < 52; z++) {
      let rescard_img = new Image();
      rescard_img.src = resultCards[z].src;
      // console.log(rescard_img.src);      
    }
  }

  preloadImgs() {
    let loadedChips = 0;
    // Preload each image
    for (let n = 1; n <= 8; n++) {
      let chip_img = new Image();
      if (loadedChips !== 8) {
        loadedChips++;
        chip_img.onload = loadedChips;
        chip_img.onerror = loadedChips;
        const chipImageName = `chips_${n}`;
        chip_img.src = chipImageName;
        // console.log(chip_img.src);
      }
    }

    let imgsLoad = [cardspannel, pannel, line, bottomline,

      subttleandar, subttlebahar, andarBet,
      baharBet, bet_button, glow_button, double_button, clear_button,
      totalbet
    ]
    for (let t = 0; t < imgsLoad.length; t++) {
      let spark_img = new Image();
      const sparkImageName = imgsLoad[t];
      // console.log(sparkImageName);
      spark_img.src = sparkImageName;
      // console.log(spark_img.src);      
    }
  }


  showCardAnim(resCard) {

    // console.log(this.startVal);
    // console.log(card_items[this.startVal].src);
    // 
    document.getElementById("animCard_" + this.startVal).style.opacity = 1;
    document.getElementById("animCard_" + this.startVal).classList.add("animateimages" + this.startVal);
    // console.log(createimage);
    // animatecardsDiv.appendChild(createimage)
    if (this.startVal < 12) {
      // console.log("   --------------------  " + this.startVal);
      this.startVal++
    } else {
      // console.log("   ***************  " + this.startVal);
      clearInterval(this.myCardAnim);
      this.startVal = 0;
      //document.getElementById("animatecards").innerHTML = "";
      // console.log(resCard);
      let original = resCard;
      let reversedString = [...original].reverse().join('');
      // console.log(reversedString);

      document.getElementById("jokerCard").src = resultCards[reversedString].src;

      // result.joker
    }
  }

  // updateResult = (result) => {
  //   // console.log(result);

  //   for (let k = 0; k < resultCards.length; k++) {
  //     if (resultCards[k].rsc_val === result.joker && document.getElementById("resJokerCard")) {
  //       // console.log(resultCards[k].src);
  //       // document.getElementById("resJokerCard").src = resultCards[k].src;
  //       document.getElementById("resJokerCard").style.opacity = 0;
  //       document.getElementById("topleft").textContent = resultCards[k].rsc_val.slice(0, -1) === 'T' ? '10' : resultCards[k].rsc_val.slice(0, -1);
  //       document.getElementById("centerdiv").textContent = resultCards[k].rsc_val.slice(0, -1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(0, -1) === "D" ? '♦' : resultCards[k].rsc_val.slice(0, -1) === "C" ? '♣' : '♠';
  //       document.getElementById("bottomright").textContent = resultCards[k].rsc_val.slice(-1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(-1) === "D" ? '♦' : resultCards[k].rsc_val.slice(-1) === "C" ? '♣' : '♠';
  //       document.getElementById("topleft").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
  //       document.getElementById("centerdiv").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
  //       document.getElementById("bottomright").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";

  //       document.getElementById("resJokerCard").style.opacity = 1;
  //       document.getElementById("resJokerCard").style.display = "block";
  //     }
  //   }

  //   this.ab_ch_timeout2 = setTimeout(() => {
  //     this.myCardAnim = setInterval(() => {
  //     }, 150);
  //     this.dealerCards(result);
  //   }, 100)


  // }

  // dealerCards = (result) => {
  // // console.log("Deal AB Cards");

  //   this.audio = new Audio(cardFallSound);
  //   this.audioD = new Audio(cardFallSound);

  //   this.setState({
  //     AndarCards: [],
  //     BaharCards: [],
  //   })

  //   this.setState({
  //     AndarCards: result.andharCards,
  //     BaharCards: result.baharCards,
  //   });
  //   // console.log(this.state.AndarCards);
  //   // console.log(this.state.BaharCards);

  //   /****************DEALER CARDS SHOWING AFTER DEAL START ******************/

  //   this.ab_ch_timeout3 = setTimeout(() => {

  //     // document.getElementById("resJokerCard").src = "";
  //     for (let k = 0; k < resultCards.length; k++) {
  //       if (resultCards[k].rsc_val === result.joker && document.getElementById("resJokerCard")) {
  //       // console.log(resultCards[k].rsc_val)
  //         // console.log(resultCards[k].src);
  //         // document.getElementById("resJokerCard").src = resultCards[k].src;
  //         document.getElementById("resJokerCard").style.opacity = 0;
  //         document.getElementById("topleft").textContent = resultCards[k].rsc_val.slice(0, -1) === 'T' ? '10' : resultCards[k].rsc_val.slice(0, -1);
  //         document.getElementById("centerdiv").textContent = resultCards[k].rsc_val.slice(-1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(-1) === "D" ? '♦' : resultCards[k].rsc_val.slice(-1) === "C" ? '♣' : '♠';
  //         document.getElementById("bottomright").textContent = resultCards[k].rsc_val.slice(-1) === 'H' ? '♥' : resultCards[k].rsc_val.slice(-1) === "D" ? '♦' : resultCards[k].rsc_val.slice(-1) === "C" ? '♣' : '♠';
  //         document.getElementById("topleft").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
  //         document.getElementById("centerdiv").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
  //         document.getElementById("bottomright").style.color = resultCards[k].rsc_val.slice(-1) === 'H' || resultCards[k].rsc_val.slice(-1) === 'D' ? "red" : "black";
  //         document.getElementById("resJokerCard").style.opacity = 1;
  //         document.getElementById("resJokerCard").style.display = "block";
  //       }
  //     }

  //     let andarArray = [];
  //     for (let v = 0; v < this.state.AndarCards.length; v++) {
  //       for (let b = 0; b < resultCards.length; b++) {
  //         if (resultCards[b].rsc_val === this.state.AndarCards[v]) {
  //           andarArray.push(resultCards[b].src);
  //         }
  //       }
  //     }

  //     let baharArray = [];
  //     for (let pl = 0; pl < this.state.BaharCards.length; pl++) {
  //       for (let rs = 0; rs < resultCards.length; rs++) {
  //         if (resultCards[rs].rsc_val === this.state.BaharCards[pl]) {
  //           baharArray.push(resultCards[rs].src);
  //         }
  //       }
  //     }

  //     let totalCardsTime = andarArray.length + baharArray.length;

  //     let pCount = 0;
  //     let dCount = 0;
  //     const myLoop = (dPlus) => {
  //       // this.cardSound.play()
  //       // if (dPlus % 2 == 0) {
  //       //   if (this.audioD) {
  //       //     this.audioD.currentTime = 0;
  //       //     this.audioD.play()
  //       //   }
  //       //   document.getElementById('res_andar_Card').style.display = "block";
  //       //   let img = document.createElement('img');
  //       //   img.classList.add("abc_andarBox");
  //       //   img.src = andarArray[dCount];
  //       //   document.getElementById('res_andar_Card').appendChild(img);

  //       //   dCount++;
  //       // } else {
  //       //   if (this.audio) {
  //       //     this.audio.currentTime = 0;
  //       //     this.audio.play()
  //       //   }
  //       //   document.getElementById('res_bahar_Card').style.display = "block";
  //       //   let img2 = document.createElement('img');
  //       //   img2.classList.add("abc_baharBox");
  //       //   img2.src = baharArray[pCount];
  //       //   document.getElementById('res_bahar_Card').appendChild(img2);
  //       //   pCount++;
  //       // }


  //       const portrait = window.innerHeight > window.innerWidth;


  //       if (dPlus % 2 === 0) {
  //         if (this.audioD) {
  //           this.cardSound.play()

  //           // try {
  //           //   this.audioD.currentTime = 0;
  //           //   this.audioD.play()
  //           // } catch (e) { console.log(e) }

  //           // try {
  //           //   const audioInstance = new Audio(this.audioD.src); // Clone
  //           //   audioInstance.currentTime = 0;
  //           //   audioInstance.play().catch(err => {
  //           //     console.warn("Playback failed", err);
  //           //   });
  //           // } catch (e) { console.log(e) }
  //         }

  //         const andarCard = document.getElementById('res_andar_Card');
  //         andarCard.style.display = "block";
  //         const card = document.createElement('div');
  //         card.classList.add("abcards");
  //         card.style.color = this.state.AndarCards[dCount].slice(-1) === 'H' || this.state.AndarCards[dCount].slice(-1) === 'D' ? "red" : "black"
  //         const topLeft = document.createElement('div');
  //         topLeft.classList.add("topleft");
  //         topLeft.textContent = this.state.AndarCards[dCount].slice(0, -1) === 'T' ? '10' : this.state.AndarCards[dCount].slice(0, -1);
  //         const center = document.createElement('div');
  //         center.classList.add("centerdiv");
  //         center.textContent = this.state.AndarCards[dCount].slice(-1) === 'H' ? '♥' : this.state.AndarCards[dCount].slice(-1) === "D" ? '♦' : this.state.AndarCards[dCount].slice(-1) === "C" ? '♣' : '♠'; //
  //         const bottomRight = document.createElement('div');
  //         bottomRight.classList.add("bottomright");
  //         bottomRight.textContent = this.state.AndarCards[dCount].slice(-1) === 'H' ? '♥' : this.state.AndarCards[dCount].slice(-1) === "D" ? '♦' : this.state.AndarCards[dCount].slice(-1) === "C" ? '♣' : '♠';;
  //         card.appendChild(topLeft);
  //         card.appendChild(center);
  //         card.appendChild(bottomRight);
  //         andarCard.appendChild(card);

  //         // const img = document.createElement('img');
  //         // img.classList.add("abc_andarBox");
  //         // img.src = andarArray[dCount];
  //         // andarCard.appendChild(img);

  //         // GSAP Animation based on orientation
  //         gsap.from(card, {
  //           duration: 0.3,
  //           width: 10,
  //           height: 10,
  //           transformOrigin: "center center",
  //           opacity: 0,
  //           zIndex: 99,
  //           x: portrait ? 400 : 950,
  //           y: portrait ? -715 : -375,
  //           z: portrait ? 600 : 600,
  //           ease: "power1.inOut"
  //         });

  //         dCount++;

  //       } else {
  //         if (this.audio) {
  //           this.cardSound.play()
  //           // try {
  //           //   this.audio.currentTime = 0;
  //           //   this.audio.play()
  //           // } catch (e) { console.log(e) }
  //           // try {
  //           //   const audioInstance = new Audio(this.audio.src); // Clone
  //           //   audioInstance.currentTime = 0;
  //           //   audioInstance.play().catch(err => {
  //           //     console.warn("Playback failed", err);
  //           //   });
  //           // } catch (e) { console.log(e) }
  //         }

  //         const baharCard = document.getElementById('res_bahar_Card');
  //         baharCard.style.display = "block";


  //         const card = document.createElement('div');
  //         card.classList.add("abcards");
  //         card.style.color = this.state.BaharCards[pCount].slice(-1) === 'H' || this.state.BaharCards[pCount].slice(-1) === 'D' ? "red" : "black"
  //         const topLeft = document.createElement('div');
  //         topLeft.classList.add("topleft");
  //         topLeft.textContent = this.state.BaharCards[pCount].slice(0, -1) === 'T' ? '10' : this.state.BaharCards[pCount].slice(0, -1);
  //         const center = document.createElement('div');
  //         center.classList.add("centerdiv");
  //         center.textContent = this.state.BaharCards[pCount].slice(-1) === 'H' ? '♥' : this.state.BaharCards[pCount].slice(-1) === "D" ? '♦' : this.state.BaharCards[pCount].slice(-1) === "C" ? '♣' : '♠'; //
  //         const bottomRight = document.createElement('div');
  //         bottomRight.classList.add("bottomright");
  //         bottomRight.textContent = this.state.BaharCards[pCount].slice(-1) === 'H' ? '♥' : this.state.BaharCards[pCount].slice(-1) === "D" ? '♦' : this.state.BaharCards[pCount].slice(-1) === "C" ? '♣' : '♠';;
  //         card.appendChild(topLeft);
  //         card.appendChild(center);
  //         card.appendChild(bottomRight);
  //         baharCard.appendChild(card);

  //         // const img2 = document.createElement('img');
  //         // img2.classList.add("abc_baharBox");
  //         // img2.src = baharArray[pCount];
  //         // baharCard.appendChild(img2);

  //         // GSAP Animation based on orientation
  //         gsap.from(card, {
  //           duration: 0.3,
  //           width: 10,
  //           height: 10,
  //           zIndex: 99,
  //           transformOrigin: "center center",
  //           opacity: 0,
  //           x: portrait ? -230 : 250,
  //           y: portrait ? -737 : -375,
  //           z: portrait ? 400 : 400,
  //           ease: "power3.inOut"
  //         });

  //         pCount++;
  //       }
  //     }

  //     let i = 0;
  //     const countDlr = () => {
  //       let dPlus = i++;
  //       if (dPlus < totalCardsTime) {
  //         myLoop(dPlus);
  //       }
  //     }

  //     this.myDlr = setInterval(function () {
  //       countDlr()
  //     }, 500);

  //   // console.log("totalCardsTime " + totalCardsTime)

  //     if (totalCardsTime == 1) {
  //       totalCardsTime = 1.5;
  //     }

  //     let waittime = 600;

  //     if (totalCardsTime > 10) {
  //       waittime = 550
  //     }

  //     this.ab_ch_timeout4 = setTimeout(() => {
  //       clearInterval(this.myDlr);
  //     // console.log("---------------------------")
  //     // console.log("Declare Result");

  //       this.props.declare_Result();
  //     }, (totalCardsTime * waittime));

  //   }, 150);
  // };

  setJokerCard = (result) => {
    if (!result?.joker) {
      return
    }

    if (this.slotSound) {
      try {
        this.slotSound.currentTime = 0;
        this.slotSound.stop();
      } catch (e) {
        // console.log(e)
      }
    }
    // document.getElementById("topleft").textContent = result.joker.slice(0, -1) === 'T' ? '10' : result.joker.slice(0, -1);
    // document.getElementById("centerdiv").textContent = result.joker.slice(-1) === 'H' ? '♥' : result.joker.slice(-1) === "D" ? '♦' : result.joker.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("bottomright").textContent = result.joker.slice(-1) === 'H' ? '♥' : result.joker.slice(-1) === "D" ? '♦' : result.joker.slice(-1) === "C" ? '♣' : '♠';
    // document.getElementById("topleft").style.color = result.joker.slice(-1) === 'H' || result.joker.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("centerdiv").style.color = result.joker.slice(-1) === 'H' || result.joker.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("bottomright").style.color = result.joker.slice(-1) === 'H' || result.joker.slice(-1) === 'D' ? "red" : "black";
    // document.getElementById("resJokerCard").appendChild(this.createCardDiv(result.joker));
    // console.log(result)
    const jokerCard = this.createCardDiv(result.joker);
    // document.getElementById("resJokerCard").style.opacity = 0;
    // console.dir(jokerCard)
    jokerCard.className = "resJokerCard_anim ABC_CardsResult cardsresult"
    jokerCard.id = "resJokerCard"
    const resJokerCard = document.getElementById("abc_jokerCardRuslt");
    // resJokerCard.innerHTML = ''; // optional: clear previous contents
    [...resJokerCard.children].forEach(child => {
      if (child.tagName === 'DIV') {
        resJokerCard.removeChild(child);
      }
    });
    resJokerCard.appendChild(jokerCard);

    document.getElementById("resJokerCard").style.opacity = 1;
    document.getElementById("resJokerCard").style.display = "block";


    this.props.playVideo()
  }


  setJokerRollCard() {
    document.getElementById("resJokerCardGIf").src = joker_card_anim;
    document.getElementById("resJokerCardGIf").style.opacity = 1;
    document.getElementById("resJokerCardGIf").style.display = "block";
    if (this.slotSound) {
      try {
        this.slotSound.currentTime = 0;
        this.slotSound.play();
      } catch (e) {
        // console.log(e)
      }
    }
    this.ab_ch_timeout8 = setTimeout(() => {
      document.getElementById("resJokerCardGIf").style.opacity = 0;
      document.getElementById("resJokerCardGIf").style.display = "none";
      this.setJokerCard(this.props.gameState)
    }, 2500)
  }

  updateResult = (result) => {
    let missing_joker_card = false;
    if (result.joker) {
      // console.log("-------------------------------------------------------------------------------");
      // console.log("-------------------------------------------------------------------------------");
      // console.log("Not missed");
      // console.log("-------------------------------------------------------------------------------");
      // console.log("-------------------------------------------------------------------------------");
      // this.setJokerCard(result)
      missing_joker_card = false;
    }
    else {
      missing_joker_card = true;
    }
    this.ab_ch_timeout2 = setTimeout(() => {
      this.myCardAnim = setInterval(() => {
      }, 150);
      this.dealerCards(result, missing_joker_card);
    }, 150)
  }

  // suitSymbol = (suit) => {
  //   // return {
  //   //   'H': '♥',
  //   //   'D': '♦',
  //   //   'C': '♣',
  //   //   'S': '♠',
  //   // }[suit] || '';
  //   return {
  //     "D": <div className="diamondCard"></div>,
  //     "S": <div className="spadeCard"><div className="spadeTale"></div></div>,
  //     "C": <div className="clubCard"><div className="clubTale"></div></div>,
  //     "H": <div className="heartCard"></div>
  //   }[suit] || <></>

  // };


  suitSymbol = (suit) => {
    const div = document.createElement('div');

    switch (suit) {
      case 'D':
        div.className = 'diamondCard';
        return div;
      case 'H':
        div.className = 'heartCard';
        return div;
      case 'S':
        div.className = 'spadeCard';
        const spadeTale = document.createElement('div');
        spadeTale.className = 'spadeTale';
        div.appendChild(spadeTale);
        return div;
      case 'C':
        div.className = 'clubCard';
        const clubTale = document.createElement('div');
        clubTale.className = 'clubTale';
        div.appendChild(clubTale);
        return div;
      default:
        return document.createElement('div'); // empty fallback
    }
  };

  suitHistorySymbol = (suit) => {
    switch (suit) {
      case 'D':
        return <div className="diamondCard" />;
      case 'H':
        return <div className="heartCard" />;
      case 'S':
        return (
          <div className="spadeCard">
            <div className="spadeTale" />
          </div>
        );
      case 'C':
        return (
          <div className="clubCard">
            <div className="clubTale" />
          </div>
        );
      default:
        return <div />; // Return an empty div as fallback
    }
  };



  createCardDiv = (value) => {
    const suit = value.slice(-1);
    const rank = value.slice(0, -1) === 'T' ? '10' : value.slice(0, -1);
    const color = (suit === 'H' || suit === 'D') ? 'red' : 'black';
    const symbol = this.suitSymbol(suit);

    const card = document.createElement('div');
    card.className = "abcards ABC_CardsResult";
    card.style.color = color;

    const topLeft = document.createElement('div');
    topLeft.className = "topleft";
    topLeft.textContent = rank;

    const center = document.createElement('div');
    center.className = "centerdiv";
    center.appendChild(symbol);

    const bottomRight = document.createElement('div');
    bottomRight.className = "bottomright";
    bottomRight.appendChild(symbol.cloneNode(true)); // Clone for second placement


    card.appendChild(topLeft);
    card.appendChild(center);
    card.appendChild(bottomRight);

    return card;
  };

  dealerCards = (result, missing_joker_card) => {
    // console.log("Deal AB Cards");
    // if miss joker card start...................................

    if (result.joker && missing_joker_card) {

      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
      // console.log("missed");
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");

      this.setJokerCard(result)
      missing_joker_card = false;
    }
    // if miss joker card end...................................
    // Cloneable audio play function
    const playAudio = () => {
      const audio = new Audio(cardFallSound);
      audio.currentTime = 0;
      audio.play().catch(err => console.warn("Audio failed:", err));
    };

    // Combine state updates
    // console.log(result, result.and)
    this.setState({
      AndarCards: result.andharCards,
      BaharCards: result.baharCards,
    }, () => {
      // Run after state is set
      this.ab_ch_timeout3 = setTimeout(() => {
        const getCardSrc = (value) => {
          const cardObj = resultCards.find(c => c.rsc_val === value);
          return cardObj?.src || "";
        };
        // console.log(this.state.AndarCards, this.state.BaharCards)
        const andarArray = this.state.AndarCards.map(getCardSrc).filter(Boolean);
        const baharArray = this.state.BaharCards.map(getCardSrc).filter(Boolean);

        const totalCardsTime = andarArray.length + baharArray.length;
        let dCount = 0;
        let pCount = 0;
        const portrait = window.innerHeight > window.innerWidth;




        const animateCard = (element, isAndar) => {
          const x = isAndar ? (portrait ? 450 : 950) : (portrait ? -300 : 250);
          const y = portrait ? -800 : -455;
          const z = isAndar ? 600 : 400;

          gsap.from(element, {
            duration: 0.3,
            // width: 10,
            // height: 10,
            scale: 0,
            zIndex: 99,
            transformOrigin: "center center",
            opacity: 0,
            x,
            y,
            z,
            ease: "power1.inOut",
          });
        };

        const dealOneCard = (index) => {
          const isAndar = index % 2 === 0;
          const cardValue = isAndar ? this.state.AndarCards[dCount] : this.state.BaharCards[pCount];
          const containerId = isAndar ? 'res_andar_Card' : 'res_bahar_Card';
          const container = document.getElementById(containerId);

          if (!cardValue || !container) return;

          playAudio();
          container.style.display = "block";

          const card = this.createCardDiv(cardValue);
          container.appendChild(card);
          animateCard(card, isAndar);

          if (isAndar) dCount++;
          else pCount++;
        };

        // let i = 0;
        // const interval = 500;
        // this.myDlr = setInterval(() => {
        //   if (i < totalCardsTime) {
        //     dealOneCard(i++);
        //   } else {
        //     clearInterval(this.myDlr);
        //   // console.log("Declare Result");
        //     this.props.declare_Result();
        //   }
        // }, interval);


        // ------------------------------------------------------
        let i = 0;
        const interval = 500;

        // console.log("totalCardsTime:", totalCardsTime);

        const intervalId = setInterval(() => {
          if (i < totalCardsTime) {
            // console.log("counting", i, totalCardsTime);
            try {
              const jokerEl = document.getElementById("resJokerCard");
              if (jokerEl && window.getComputedStyle(jokerEl).display === "none") {
                jokerEl.style.display = "block";
              }


              dealOneCard(i);
            } catch (err) {
              console.error("Error in dealOneCard:", err);
              clearInterval(intervalId);
            }
            i++;
          } else {
            clearInterval(intervalId);
            // console.log("Declare Result");
            this.props.declare_Result?.(); // Optional chaining
            // console.log("uncounting", i, totalCardsTime);
          }
        }, interval);
        // ------------------------------------------------------



      }, 150);
    });
  };

  sideBets(betId) {
    // console.log(this.state.chipSelect);
    // console.log(betId);
    if (this.props.totalBetAmount == 0) {
      this.removeWinGlow();
    }


    this.props.enableKeyboard(false);
    clearInterval(this.startInt);
    if (document.getElementById(betId)) {
      document.getElementById(betId).style.transform = "scale(0.65)";
    }
    this.props.selecteSuit(betId);
    this.playPokerBetSound(this.betoncard);

    if (!this.props.isMobile) {
      this.startInt = setInterval(() => {
        this.playPokerBetSound(this.betoncard);
        this.props.selecteSuit(betId);
      }, 120);
    }





  }


  mouseDownSelectCard(data) {
    // this.cardanimation();
    if (this.props.totalBetAmount == 0) {
      this.removeWinGlow();
    }

    clearInterval(this.startIntCard);
    // document.getElementById("card_" + data).style.transform = "scale(0.9)";
    this.props.selectedCard(data)
    this.props.enableKeyboard(false);
    // this.betoncard = new Audio(betoncard)
    // this.betoncard.play();
    this.playPokerBetSound(this.betoncard);

    this.startIntCard = setInterval(() => {
      this.playPokerBetSound(this.betoncard);
      this.props.selectedCard(data)
    }, 120);

  }
  TouchDownSelectCard(data) {
    // this.cardanimation();
    if (this.props.totalBetAmount == 0) {
      this.removeWinGlow();
    }


    // document.getElementById("card_" + data).style.transform = "scale(0.9)";
    this.props.selectedCard(data)
    this.props.enableKeyboard(false);
    // this.betoncard = new Audio(betoncard)
    // this.betoncard.play();
    this.playPokerBetSound(this.betoncard);

  }
  mouseUpStopCards = (cardNum) => {

    clearInterval(this.startIntCard);
    this.ab_ch_timeout5 = setTimeout(() => {
      this.props.enableKeyboard(true);
      if (document.getElementById("card_" + cardNum)) {
        // document.getElementById("card_" + cardNum).style.transform = "scale(1)";
      }
    }, 100);
  }
  TouchEndUpStopCards = (cardNum) => {

    this.ab_ch_timeout5 = setTimeout(() => {
      this.props.enableKeyboard(true);
      if (document.getElementById("card_" + cardNum)) {
        // document.getElementById("card_" + cardNum).style.transform = "scale(1)";
      }
    }, 100);
  }

  mouseUpSideBets(betId) {
    clearInterval(this.startInt);
    this.setState({ onHover: false });


    switch (betId) {
      case "ander_betImg":
        if (document.getElementById("abc_andar_glow") && !document.getElementById("abc_andar_glow").classList.contains("abc_andarbetGlowAnim")) {

          this.setState({ andar_hover: false });
          document.getElementById("abc_andar_glow").style.display = "none";
        }
        break;
      case "abc_bahar_bet":
        if (document.getElementById("abc_bahar_glow") && !document.getElementById("abc_bahar_glow").classList.contains("abc_andarbetGlowAnim")) {

          this.setState({ bahar_hover: false });
          document.getElementById("abc_bahar_glow").style.display = "none";
        }
        break;
      case "one_sixImg":
        // if (!document.getElementById("glow_a6").classList.contains("abc_andarbetGlowAnim")) {

        //   this.setState({ ato6_hover: false });
        //   document.getElementById("glow_a6").style.display = "none";
        // }
        break;
      case "glow_8k":
        // if (!document.getElementById("glow_8k").classList.contains("abc_andarbetGlowAnim")) {

        //   document.getElementById("glow_8k").style.display = "none";
        //   this.setState({ hover_8tok: false });
        // }
        break;
      case "heart_suit":
        // if (!document.getElementById("heart_glow").classList.contains("abc_andarbetGlowAnim")) {

        //   document.getElementById("heart_glow").style.display = "none";
        //   this.setState({ heart_hover: false });
        // }
        break;
      case "spade_suit":
        // if (!document.getElementById("spade_glow").classList.contains("abc_andarbetGlowAnim")) {
        //   document.getElementById("spade_glow").style.display = "none";
        //   this.setState({ spade_hover: false });
        // }
        break;
      case "club_suit":
        // if (!document.getElementById("club_glow").classList.contains("abc_andarbetGlowAnim")) {
        //   this.setState({ club_hover: false });
        //   document.getElementById("club_glow").style.display = "none";
        // }
        break;
      case "dimond_suit":
        // if (!document.getElementById("dimond_glow").classList.contains("abc_andarbetGlowAnim")) {
        //   this.setState({ dimond_hover: false });
        //   document.getElementById("dimond_glow").style.display = "none";
        // }
        break;
      default:
        break;
    }
    this.ab_ch_timeout6 = setTimeout(() => {
      this.props.enableKeyboard(true);
      if (document.getElementById(betId)) {
        // document.getElementById(betId).style.transition = "250ms linear";
        // document.getElementById(betId).style.transform = "scale(1)";
      }
    }, 100);
  }

  mouseOverfn(betName) {

    // this.setState({onHover: true});
    // console.log("**********************************  " + betName);
    // console.log(document.getElementById(betName))
    if (document.getElementById(betName)) {
      switch (betName) {
        case "ander_betImg":
          this.setState({ andar_hover: true });
          if (document.getElementById("abc_andar_glow")) {
            document.getElementById("abc_andar_glow").style.display = "block";
          }
          break;
        case "abc_bahar_bet":
          this.setState({ bahar_hover: true });
          if (document.getElementById("abc_bahar_glow")) {
            document.getElementById("abc_bahar_glow").style.display = "block";
          }
          break;
        case "one_sixImg":
          this.setState({ ato6_hover: true });
          // document.getElementById("glow_a6").style.display = "block";
          break;
        case "glow_8k":
          this.setState({ hover_8tok: true });
          // document.getElementById("glow_8k").style.display = "block";
          break;
        case "heart_suit":
          this.setState({ heart_hover: true });
          // document.getElementById("heart_glow").style.display = "block";
          break;
        case "spade_suit":
          this.setState({ spade_hover: true });
          // document.getElementById("spade_glow").style.display = "block";

          break;
        case "club_suit":
          this.setState({ club_hover: true });
          // document.getElementById("club_glow").style.display = "block";
          break;
        case "dimond_suit":
          this.setState({ dimond_hover: true });
          // document.getElementById("dimond_glow").style.display = "block";
          break;
        // case "card":         
        //   this.setState({ card_hover: true });
        //   break;
        default:
          break;
      }

    }

  }

  updateHistory(historyData) {

    if (historyData.length == 0) {
      return;
    }
    this.History = historyData
    // console.log(historyData)
    // console.log(historyData.length)
    for (let j = 1; j <= 4; j++) {
      if (historyData.length < j) {
        if(document.getElementById("ab_hist_" + j))
        document.getElementById("ab_hist_" + j).style.display = "none";
      }
    }

    if (historyData.length > 0 && historyData.length >= 4) {
      for (let a = 0; a < historyData.length; a++) {
        for (let b = 0; b < resultCards.length; b++) {
          if (resultCards[b].rsc_val === historyData[a].resultNo) {
            if (document.getElementById("hisCard_" + a)) {
              document.getElementById("hisCard_" + a).src = resultCards[b].src
            }
            // console.log(historyData[a].extraInfo);
            if (a == 0) {
              if (historyData[a].extraInfo == "BAHAR") {
                this.setState({ andarBg_0: false })
              } else {
                this.setState({ andarBg_0: true })
              }
            } else if (a == 1) {
              if (historyData[a].extraInfo == "BAHAR") {
                this.setState({ andarBg_1: false })
              } else {
                this.setState({ andarBg_1: true })
              }
            } else if (a == 2) {
              if (historyData[a].extraInfo == "BAHAR") {
                this.setState({ andarBg_2: false })
              } else {
                this.setState({ andarBg_2: true })
              }
            } else if (a == 3) {
              if (historyData[a].extraInfo == "BAHAR") {
                this.setState({ andarBg_3: false })
              } else {
                this.setState({ andarBg_3: true })
              }
            }
          }
        }
      }

    }
  }

  btn_fn(betId) {
    switch (betId) {
      case "doubleBtn":
        if (this.betSound) {
          this.betSound.play();
        }
        this.props.doubleAmount();
        break;
      case "betBtn":
        if (this.props.betButtonValue == 2) {
          if (this.takeSound) {
            this.takeSound.play();
          }
        } else {
          if (this.betSound) {
            this.betSound.play();
          }
        }
        this.props.bet_fn();
        break;
      case "clearBtn":
        if (!this.props.isBetSent) {
          if (this.clearSound) {
            this.clearSound.play();
          }
          this.props.clear_fn();
        }
        break;
      // case "exitBtn":
      //   this.props.action();
      default:
        break;
    }

  }

  glowWinImg(data) {
    // console.log("--------------------***********************----------------------")
    this.removeWinGlow();
    // console.log(data)
    // document.getElementById("card_glow_" + data[0]).classList.add("abc_cardbetGlow");

    if (data[0] !== 0) {
      // console.log("glow rank card");
    }
    // if (data[1] !== 0) {
    switch (data[1]) {
      case 1:
        this.setState({ club_hover: true });
        // document.getElementById("club_glow").style.display = "block";
        // document.getElementById("club_glow").classList.add("abc_andarbetGlowAnim");


        break;
      case 2:
        this.setState({ dimond_hover: true });
        // document.getElementById("dimond_glow").style.display = "block";
        // document.getElementById("dimond_glow").classList.add("abc_andarbetGlowAnim");


        break;
      case 3:
        this.setState({ heart_hover: true });
        // document.getElementById("heart_glow").style.display = "block";
        // document.getElementById("heart_glow").classList.add("abc_andarbetGlowAnim");
        break;
      case 0:
        this.setState({ spade_hover: true });
        // document.getElementById("spade_glow").style.display = "block";
        // document.getElementById("spade_glow").classList.add("abc_andarbetGlowAnim");
        break;
    }
    // }
    if (data[2] !== -1) {
      if (data[2] == 0) {
        // console.log("glow 1-6");
        this.setState({ ato6_hover: true });
        // document.getElementById("glow_a6").style.display = "block";
        // document.getElementById("glow_a6").classList.add("abc_andarbetGlowAnim");
      } else if (data[2] == 1) {
        // console.log("glow 8-k");
        this.setState({ hover_8tok: true });
        // document.getElementById("glow_8k").style.display = "block";
        // document.getElementById("glow_8k").classList.add("abc_andarbetGlowAnim");

      }
    }
    if (data[0] == 0) {
      this.setState({ andar_hover: true, andarBgGlow: true });
      if (document.getElementById("abc_andar_glow")) {
        document.getElementById("abc_andar_glow").style.display = "block";
        document.getElementById("abc_andar_glow").classList.add("abc_andarbetGlowAnim")
      }
    } else if (data[0] == 1) {
      this.setState({ bahar_hover: true, baharBgGlow: true });
      if (document.getElementById("abc_bahar_glow")) {
        document.getElementById("abc_bahar_glow").style.display = "block";
        document.getElementById("abc_bahar_glow").classList.add("abc_andarbetGlowAnim")
      }
    }


  }
  removeWinGlow() {
    for (let i = 0; i < 13; i++) {
      // if (document.getElementById("card_glow_" + i).classList.contains("abc_cardbetGlow")) {
      //   document.getElementById("card_glow_" + i).classList.remove("abc_cardbetGlow")
      // }
    }
    this.setState({ heart_hover: false });
    // document.getElementById("heart_glow").style.display = "none";
    // if (document.getElementById("heart_glow").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("heart_glow").classList.remove("abc_andarbetGlowAnim");
    // }

    this.setState({ spade_hover: false });
    // document.getElementById("spade_glow").style.display = "none";
    // if (document.getElementById("spade_glow").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("spade_glow").classList.remove("abc_andarbetGlowAnim");
    // }

    this.setState({ club_hover: false });
    // document.getElementById("club_glow").style.display = "none";
    // if (document.getElementById("club_glow").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("club_glow").classList.remove("abc_andarbetGlowAnim");
    // }

    this.setState({ dimond_hover: false });
    // document.getElementById("dimond_glow").style.display = "none";
    // if (document.getElementById("dimond_glow").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("dimond_glow").classList.remove("abc_andarbetGlowAnim");
    // }

    this.setState({ ato6_hover: false });
    // document.getElementById("glow_a6").style.display = "none";
    // if (document.getElementById("glow_a6").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("glow_a6").classList.remove("abc_andarbetGlowAnim");
    // }

    this.setState({ hover_8tok: false });
    // document.getElementById("glow_8k").style.display = "none";
    // if (document.getElementById("glow_8k").classList.contains("abc_andarbetGlowAnim")) {
    //   document.getElementById("glow_8k").classList.remove("abc_andarbetGlowAnim");
    // }
    if (document.getElementById("abc_andar_glow")) {

      this.setState({ andar_hover: false, andarBgGlow: false });
      document.getElementById("abc_andar_glow").style.display = "none";
      if (document.getElementById("abc_andar_glow").classList.contains("abc_andarbetGlowAnim")) {
        document.getElementById("abc_andar_glow").classList.remove("abc_andarbetGlowAnim");
      }
    }
    if (document.getElementById("abc_bahar_glow")) {
      this.setState({ bahar_hover: false, baharBgGlow: false });
      document.getElementById("abc_bahar_glow").style.display = "none";
      if (document.getElementById("abc_bahar_glow").classList.contains("abc_andarbetGlowAnim")) {
        document.getElementById("abc_bahar_glow").classList.remove("abc_andarbetGlowAnim");
      }
    }
  }
  closePop() {
    this.audio = new Audio(cardFallSound);
    this.audioD = new Audio(cardFallSound);
    this.betoncard = new Audio(betoncard);
    this.betSound = new Audio(betSound);
  }

  render() {

    return (
      <React.Fragment>
        <div className="abc_gameArea" style={{ marginTop: window.innerHeight > window.innerWidth ? "50px" : "80px" }}>


          {/* <div className="abc_cardscontainer">
            <img className="titleline" src={line} />
            {card_items.map((data) => (
              <div
                className={(this.props.isMobile) ? "emptyPointer cardDiv" : "addCursorPointer cardDiv"}
                id={"card_" + data.c_val}
                key={data.c_val}

                onMouseDown={(e) => {
                  e.preventDefault();
                  // e.currentTarget.style.transform = "scale(0.9)";
                  this.mouseDownSelectCard(data.c_val)

                  // this.props.selectedCard(data.c_val);
                }}
                // onPointerDown={(e) => {

                //   e.preventDefault();
                //   this.TouchDownSelectCard(data.c_val)
                //   // e.currentTarget.style.transform = "scale(0.9)";
                //   // this.props.selectedCard(data.c_val);
                // }}
                onMouseUp={(e) => this.mouseUpStopCards(e, data.c_val)}
                onMouseOut={(e) => this.mouseUpStopCards(e, data.c_val)}
              // onPointerLeave={(e) => {
              //    e.preventDefault();
              //   this.TouchEndUpStopCards(e, data.c_val)
              // }}

              >
                <div className="card">
                  <div className="top-left">♣</div>
                  <div className="top-right">♥</div>
                  <div className="center">{data.c_val === '0' ? 'A' : data.c_val === '10' ? 'J' : data.c_val === '11' ? 'Q' : data.c_val === '12' ? 'K' : Number(data.c_val) + 1}</div>
                  <div className="bottom-left">♦</div>
                  <div className="bottom-right">♠</div>
                </div>
                <div id={"card_glow_" + data.c_val}></div>
                <div className="ab_gldDiv abc_goldcoin" id={"fID_" + data.c_val}>

                </div>
              </div>
            ))}

            <img className="titlelinebottom" src={line} />
          </div> */}

          <div className="row suitBetArea ABC_SuitBetArea" style={{ marginBottom: "80px" }}>
            {/* <div className="colSize1"> */}
            <div className="column colSize1">
              <div className="fd historypart pblock AB_ClassicBackBox">
                <div>
                  {this.History.map((card) => {

                    return (
                      <div key={card.handId} style={{ color: card.resultNo.slice(-1) === "H" || card.resultNo.slice(-1) === "D" ? "red" : "black" }}>
                        <span>{card.resultNo.slice(0, -1) === "T" ? 10 : card.resultNo.slice(0, -1)}</span>
                        <span className="ABC_historySuits">{this.suitHistorySymbol(card.resultNo.slice(-1))}</span>
                        {/* <span style={{ fontSize: "40px", color: card.resultNo.slice(-1) === "H" || card.resultNo.slice(-1) === "D" ? "red" : "black" }}>{card.resultNo.slice(-1) === "H" ? "♥" : card.resultNo.slice(-1) === "S" ? '♠' : card.resultNo.slice(-1) === "D" ? '♦' : '♣'}</span> */}
                        <span>{card.extraInfo === "BAHAR" ? "B" : "A"}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* <div className="row abc_leftSuitRow">
                <div className={(this.props.isMobile) ? "emptyPointer heart" : "addCursorPointer heart"}

                >
                  <img id="heart_glow" className="clubbetGlow" src={(this.state.heart_hover) ? suitGlowImg : ""} />
                  <img className="abc_suitImg" id="heart_suit" src={heart} />
                  <div className="ab_gldDiv abc_suit_goldcoin" id={"heart"}></div>
                  <div
                    className={(this.props.isMobile) ? "emptyPointer dimond_hit_area" : "addCursorPointer dimond_hit_area"}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("heart");
                      document.getElementById("heart_suit").style.transform = "scale(0.9)";
                    }}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("heart");
                    //   document.getElementById("heart_suit").style.transform = "scale(0.9)";
                    // }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("heart_suit") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("heart_suit") }}

                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("heart_suit") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("heart_suit") }}
                  // onMouseLeave={(e) => { e.preventDefault(); this.mouseUpSideBets("heart_suit") }}

                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("heart_suit") }}
                  ></div>
                </div>
                <div className={(this.props.isMobile) ? "emptyPointer spade" : "addCursorPointer spade"}
                >
                  <img id="spade_glow" className="clubbetGlow" src={(this.state.spade_hover) ? suitGlowImg : ""} />
                  <img className="abc_suitImg" id="spade_suit" src={spade} />
                  <div className="ab_gldDiv abc_suit_goldcoin" id={"spade"}></div>
                  <div
                    className={(this.props.isMobile) ? "emptyPointer dimond_hit_area" : "addCursorPointer dimond_hit_area"}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("spade");
                      document.getElementById("spade_suit").style.transform = "scale(0.9)";
                    }}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("spade");
                    //   document.getElementById("spade_suit").style.transform = "scale(0.9)";
                    // }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("spade_suit") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("spade_suit") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("spade_suit") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("spade_suit") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("spade_suit") }}
                  >
                  </div>
                </div>
              </div> */}



              {/* <div className="row leftHistRow">
                <div id="ab_hist_4" className="abc_hisCard_4">
                  <img id="hisCardBg_3" src={(this.state.andarBg_3) ? andarHist : baharHist} ></img>
                  <img id="hisCard_3"></img>
                </div>
                <div id="ab_hist_3" className="hisCard_3">
                  <img id="hisCardBg_2" src={(this.state.andarBg_2) ? andarHist : baharHist} ></img>
                  <img id="hisCard_2"></img>
                </div>
              </div> */}
            </div>
            {/* <div className="colSize2"> */}
            <div className="column colSize2 abc_colSize2">






              <div className="pannelcards ABC_Pannels">

                <div id="andarCardHolder" className="fstcrd">
                  <img className={this.state.andarBgGlow ? "abc_BgGlow showGlow abc_andarbetGlowAnim" : "abc_BgGlow hideGlow"} src={cardGlow}></img>
                  <img className="fstcrd_bg" src={pannel} />
                  {/* <div className="fstcrd_bg"  ></div> */}
                  {/* <img className="andarsubttle" src={subttleandar} /> */}
                  <div className="abc_resAndarCard" id="res_andar_Card" />
                  <div
                    className={(this.props.isMobile) ? "emptyPointer BetAndarCardArea" : "addCursorPointer BetAndarCardArea"}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("andar");
                    }}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("andar");
                    // }}

                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("ander_betImg") }}

                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}

                  ></div>
                  <div style={{ position: "relative" }}>
                    <img id="abc_andar_glow" className="baharbetGlow" src={suitGlowImg} />
                    <img id="ander_betImg" className="andarBet" src={andarBet} />
                    <div className="abc_andar_goldCoin" id="andar"></div>
                  </div>
                  <div className={(this.props.isMobile) ? "emptyPointer andarBetArea" : "addCursorPointer andarBetArea"}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("andar");
                    }}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("andar");
                    // }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("ander_betImg") }}

                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("ander_betImg") }}
                  ></div>
                </div>

                <div className="sestcrd">
                  <img className="jokerCard_bg ABC_joker" id="jokerCard" src={cardspannel} />
                  {/* <div className="jokerCard_bg" id="jokerCard"  ></div> */}
                  <div className="abc_jokerCardRuslt" id="abc_jokerCardRuslt">
                    <img className="ABC_ResJokerCard resJokerCard_animGif" id="resJokerCardGIf" />
                    {/* <div className="resJokerCard_anim ABC_CardsResult cardsresult" id="resJokerCard"> */}
                    {/* <div className="topleft" id="topleft"></div>
                    {/* <div className="resJokerCard_anim ABC_CardsResult cardsresult" id="resJokerCard"> */}
                    {/* <div className="topleft" id="topleft"></div>
                      <div className="centerdiv" id="centerdiv"></div>
                      <div className="bottomright" id="bottomright"></div> */}
                    {/* </div> */}
                  </div>
                  {/* <img id="glow_a6" className="a_6_glowcard" src={(this.state.ato6_hover) ? suitGlowImg : ""} />
                  <img id="glow_8k" className="glowcard_8k" src={(this.state.hover_8tok) ? suitGlowImg : ""} />
                  <img id="one_sixImg" className="glowcard" src={numBet1} />
                  <img id="eight_KImg" className="num8_k" src={numBet2} />
                  <div className="fd a6_goldCoin" id="one_six"></div>
                  <div className={(this.props.isMobile) ? "emptyPointer one_six" : "addCursorPointer one_six"}
                    id="one_six"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("one_six");
                    }}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("one_six");
                    // }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("one_sixImg") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("one_sixImg") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("one_sixImg") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("one_sixImg") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("one_sixImg") }}
                  >
                  </div>

                  <div className="fd bottom_num_goldCoin" id="eight_k"></div>
                  <div className={(this.props.isMobile) ? "emptyPointer eight_k" : "addCursorPointer eight_k"}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("eight_k");
                    // }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("eight_k");
                    }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("glow_8k") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("glow_8k") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("glow_8k") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("glow_8k") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("glow_8k") }}
                  >


                  </div> */}
                </div>

                <div className="trdcrd">
                  <div>
                    <img className={this.state.baharBgGlow ? "abc_BgGlow showGlow abc_andarbetGlowAnim" : "abc_BgGlow hideGlow"} src={cardGlow}></img>

                    <img className="fstcrd_bg" src={pannel2} />
                    {/* <div className="fstcrd_bg"  ></div> */}
                    {/* <img className="baharsubttle" src={subttlebahar} /> */}
                    <div className="abc_resBaharCard" id="res_bahar_Card" />
                    <div
                      className={(this.props.isMobile) ? "emptyPointer BetBaharCardArea" : "addCursorPointer BetBaharCardArea"}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        this.sideBets("bahar");
                      }}
                      // onTouchStart={(e) => {
                      //   e.preventDefault();
                      //   this.sideBets("bahar");
                      // }}
                      onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("abc_bahar_bet") }}
                      onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                      onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                      onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                    // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                    ></div>
                    <div style={{ position: "relative" }}>
                      <img id="abc_bahar_glow" className="baharbetGlow" src={suitGlowImg} />
                      <img id="abc_bahar_bet" className="baharBet" src={baharBet} />
                      <div className="abc_bahar_goldCoin" id="bahar"></div>
                    </div>
                    <div className={(this.props.isMobile) ? "emptyPointer baharBetArea" : "addCursorPointer baharBetArea"}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        this.sideBets("bahar");
                      }}
                      // onTouchStart={(e) => {
                      //   e.preventDefault();
                      //   this.sideBets("bahar");
                      // }}
                      onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("abc_bahar_bet") }}
                      onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                      onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                      onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                    // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("abc_bahar_bet") }}
                    ></div>
                  </div>
                </div>

              </div>








            </div>
            {/* <div className="colSize3"> */}
            <div className="column colSize3">
              <div className="infoBox pblock ABC_info">
                <span id="infoTxt" className="infoTxt" >{this.props.infoText}</span>
              </div>
              {/* <div className="row abc_rightsuitRow">
                <div className={(this.props.isMobile) ? "emptyPointer club" : "addCursorPointer club"}

                >
                  <img id="club_glow" className="clubbetGlow" src={(this.state.club_hover) ? suitGlowImg : ""} />
                  <img className="abc_suitImg" id="club_suit" src={club} />
                  <div className="ab_gldDiv abc_suit_goldcoin" id={"club"}></div>
                  <div
                    className={(this.props.isMobile) ? "emptyPointer dimond_hit_area" : "addCursorPointer dimond_hit_area"}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("club");
                    //   document.getElementById("club_suit").style.transform = "scale(0.9)";
                    // }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("club");
                      document.getElementById("club_suit").style.transform = "scale(0.9)";
                    }}

                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("club_suit") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("club_suit") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("club_suit") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("club_suit") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("club_suit") }}
                  >
                  </div>
                </div>

                <div
                  className={(this.props.isMobile) ? "emptyPointer dimond" : "addCursorPointer dimond"}

                >
                  <img className="abc_suitImg" id="dimond_suit" src={dimond} />
                  <img id="dimond_glow" className="clubbetGlow" src={(this.state.dimond_hover) ? suitGlowImg : ""} />
                  <div className="ab_gldDiv abc_suit_goldcoin" id={"dimond"}></div>
                  <div
                    className={(this.props.isMobile) ? "emptyPointer dimond_hit_area" : "addCursorPointer dimond_hit_area"}
                    // onTouchStart={(e) => {
                    //   e.preventDefault();
                    //   this.sideBets("dimond");
                    //   document.getElementById("dimond_suit").style.transform = "scale(0.9)";
                    // }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      this.sideBets("dimond");
                      document.getElementById("dimond_suit").style.transform = "scale(0.9)";
                    }}
                    onPointerOver={(e) => { e.preventDefault(); this.mouseOverfn("dimond_suit") }}
                    onPointerOut={(e) => { e.preventDefault(); this.mouseUpSideBets("dimond_suit") }}
                    onMouseUp={(e) => { e.preventDefault(); this.mouseUpSideBets("dimond_suit") }}
                    onMouseOut={(e) => { e.preventDefault(); this.mouseUpSideBets("dimond_suit") }}
                  // onTouchEnd={(e) => { e.preventDefault(); this.mouseUpSideBets("dimond_suit") }}
                  >
                  </div>
                </div>
              </div> */}
              {/* <div className="row rightHistRow">
                <div id="ab_hist_2" className="hisCard_2">
                  <img id="hisCardBg_1" src={(this.state.andarBg_1) ? andarHist : baharHist} ></img>
                  <img id="hisCard_1"></img>
                </div>
                <div id="ab_hist_1" className="hisCard_1">
                  <img id="hisCardBg_0" src={(this.state.andarBg_0) ? andarHist : baharHist} ></img>
                  <img id="hisCard_0"></img>
                </div>

              </div> */}
            </div>
          </div>
          {/* <div className="infoBox">
            <span id="infoTxt" className="infoTxt" >{this.props.infoText}</span>
          </div> */}
          <div className="ab_Chps fd ABC_Chips">
            <ul className="chips_abc_timer">
              {/* {chips.map((chip, i) => ( */}
              {chips.filter(chip => chip.val !== 0).map((chip, i) => (
                //<li key={chip.src} >
                <div
                  className={this.props.isMobile ? `abc_chip_bg${i}` : `abc_chip_bg${i} addCursorPointer`}
                  id={"chipImg_" + chip.val}
                  key={i}
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("chipImg_" + chip.val).style.transform = "scale(0.65)";
                    this.ab_ch_timeout7 = setTimeout(() => {
                      document.getElementById("chipImg_" + chip.val).style.transform = "scale(1)";
                    }, 200);
                    this.props.getChipVal(`${this.chipVal[i].val}`, `${this.chipVal[i].label}`);
                    this.setState({ chipSelect: chip.val });
                  }
                  }
                >
                  <img src={chip.src} className={this.state.chipSelect === chip.val ? "ab_active abc_chipImg" : "inactive abc_chipImg"} alt={chip.val} />
                  <div id={"chipText_" + chip.val} class="abt_overlay_text"> {this.chipVal[i].label}</div>
                </div>
                // </li>
              ))}
            </ul>
          </div>
          {/* <div className="infoBox">
            <span id="infoTxt" className="infoTxt" >{this.props.infoText}</span>
          </div> */}
          <div className="fd historypart lblock AB_ClassicBackBox">
            <div>
              {this.History.map((card) => {

                return (
                  <div key={card.handId}>
                    <span style={{ color: card.resultNo.slice(-1) === "H" || card.resultNo.slice(-1) === "D" ? "red" : "black" }}>{card.resultNo.slice(0, -1) === "T" ? 10 : card.resultNo.slice(0, -1)}</span>
                    {/* <span>{card.resultNo.slice(-1)}</span> */}
                    <span className="ABC_historySuits">{this.suitHistorySymbol(card.resultNo.slice(-1))}</span>
                    {/* <span style={{ fontSize: "40px", color: card.resultNo.slice(-1) === "H" || card.resultNo.slice(-1) === "D" ? "red" : "black" }}>{card.resultNo.slice(-1) === "H" ? "♥" : card.resultNo.slice(-1) === "S" ? '♠' : card.resultNo.slice(-1) === "D" ? '♦' : '♣'}</span> */}
                    <span style={{ color: card.resultNo.slice(-1) === "H" || card.resultNo.slice(-1) === "D" ? "red" : "black" }} >{card.extraInfo === "BAHAR" ? "B" : "A"}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="ABC_buttonList">
            {/* <div
              id="exitBtn"
              className={this.props.isMobile ? "exitBtn" : "exitBtn addCursorPointer"}
              onClick={(e) => {
                e.preventDefault();
                this.btn_fn("exitBtn");
              }}
            >
              <img className="ab_btn_height" src={ab_exitBtn} />
              <span className="textoverEXIT">{this.props.language.Exit}</span>
            </div> */}
            <div className="spacer">
              <span>{this.props.infoText}</span>

            </div>

            <div className={this.props.isMobile ? "clearBtn" : "clearBtn addCursorPointer"}
              id="clearBtn"
              onClick={(e) => {
                e.preventDefault();
                this.btn_fn("clearBtn");
              }}
            >
              <img className="ab_btn_height" src={clear_button} />
              {/* <img className="ab_btn_height" src={take_button} /> */}
              {/* <div className="textovercancelbet">
                <span>{this.props.language.Clear}</span>
              </div> */}
            </div>

            <div className="betLbl">
              <img className="ab_btn_height totalbet" src={totalbet} />
              <div className="textovertotalbet">
                <span className="totalBetAmt">{this.props.language.TotalBet}<br /> {this.props.updatedbets}</span>
              </div>
            </div>

            <div className={this.props.isMobile ? "ab_doubleBtn" : "ab_doubleBtn addCursorPointer"}
              id="doubleBtn"
              onClick={(e) => {
                e.preventDefault();
                this.btn_fn("doubleBtn");
              }}
            >
              <img className="ab_btn_height" src={double_button} />
              {/* <div className="textoverdouble">
                <span>{this.props.language.Double}</span>
              </div> */}
            </div>
            <div className={this.props.isMobile ? "ab_betok" : "ab_betok addCursorPointer"}
              id="betBtn"
              onClick={(e) => {
                e.preventDefault();
                this.btn_fn("betBtn");
              }}
            >
              {/* <img className={this.props.startBlink ? "abbuttonglow " : "hidebuttonglow"} src={this.props.startBlink ? glow_button : ""} /> */}
              {this.props.startBlink && (
                <img className="abbuttonglow" src={glow_button} alt="Glow Button" />
              )}
              <img className="betButton ab_btn_height" src={this.props.betButtonValue ? bet_button : prev_button} />
              {/* <div className="textoverbetok">
                <span>{this.props.betBtnTxt}</span>
              </div> */}
            </div>
          </div>
          {/* <div id="ab_Cover" className="ab_Cover">
          </div> */}
          {/************************** DEALER & PLAYER TABLE END  ******************/}
        </div>
      </React.Fragment>
    );
  }
}
const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj

  }
}
export default connect(mapStatesToProps)(ab_ChipsDealerPlayer)